import { adjust } from "./util"
/** Module de calcul de la correction de densité de l'acide phosphorique */

const HOT_ACID_DENSITY_LEVELS = [
    { from: 1.180, to: 1.320, correction: 0.0004 },
    { from: 1.320, to: 1.450, correction: 0.0005 },
    { from: 1.450, to: 1.550, correction: 0.0006 },
    { from: 1.550, to: 1.660, correction: 0.0007 },
    { from: 1.660, to: 1.750, correction: 0.0008 }] // Tableau reprenant les constantes de correction de densité d'acide phosphorique

/** Fonction de correction de la densité d'acide phopshorique*/
export const densityCorrection = (mesuredTemperature, mesuredDensity, desiredTemperature) => {
    try {
        const level = HOT_ACID_DENSITY_LEVELS.find(level => mesuredDensity >= level.from && mesuredDensity <= level.to) // On récupère le palier où l'on se trouve
        const degrees = mesuredTemperature - desiredTemperature // On calcul le nombre de degrés
        const correction = adjust(level.correction * degrees, 4)
        const correctedDensity = adjust(mesuredDensity + correction, 4)
        return { correction, correctedDensity }// On retourne la correction calculée
    } catch (e) {
        throw e
    }
}

/** Accès au tableau de constantes */
export const getHotAcidDensityLevels = () => {
    return HOT_ACID_DENSITY_LEVELS
}